<template>
  <TheHeader @mode="toggleMode" />

  <section class="home" :class="homeMode">
    <ProjectList :mode="mode" />
  </section>
</template>

<script>
import ProjectList from "@/components/projects/ProjectList";
import TheHeader from "@/components/layout/TheHeader";

export default {
  name: "Home",
  data() {
    return {
      mode: "light",
    };
  },
  components: {
    ProjectList,
    TheHeader,
  },
  methods: {
    toggleMode(e) {
      this.mode = e;
    },
  },

  computed: {
    homeMode() {
      return this.mode === "light" ? "home-light" : "home-dark";
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  max-width: 144rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  // transform: translateY(-14.2rem);
  margin-top: -14.2rem;
  padding-bottom: 11.5rem;
  height: 100vh;
}

.home-light {
  background-color: #fafafa;
}

.home-dark {
  background-color: #171823;
}
</style>
